import { safeInteropRegister, toGoLang, asyncForEach } from "../../api-polyfill/src/common/windowFunctions";
import { convertFinsembleKeyArrToGlueKeyString } from "../../api-polyfill/src/hotkey";
export class HotkeyService {
    constructor(glue, logger) {
        this.glue = glue;
        this.logger = logger;
        this.hotKeyToWindowMap = {};
    }
    async maybeRemove(glueKeyString, instance) {
        const instances = this.hotKeyToWindowMap[glueKeyString];
        if (!instances) {
            return;
        }
        this.logger.debug("hotkeys - Removing global hotkey", glueKeyString, instance.applicationName, instance.instance);
        const remainingInstances = instances.filter((i) => i.windowId !== instance.windowId);
        if (!remainingInstances.length) {
            await this.glue.hotkeys.unregister(glueKeyString);
            delete this.hotKeyToWindowMap[glueKeyString];
        }
        else {
            this.hotKeyToWindowMap[glueKeyString] = remainingInstances;
        }
    }
    async addGlobalHotkey(params, instance) {
        const glueKeyString = convertFinsembleKeyArrToGlueKeyString(params.keyArr);
        const instances = this.hotKeyToWindowMap[glueKeyString];
        if (instances) {
            instances.push(instance);
        }
        else {
            this.hotKeyToWindowMap[glueKeyString] = [instance];
            this.logger.debug("hotkeys - Adding global hotkey", glueKeyString, instance.applicationName, instance.instance);
            await this.glue.hotkeys.register(glueKeyString, async () => {
                const currentInstances = this.hotKeyToWindowMap[glueKeyString] ?? [];
                await asyncForEach(currentInstances, async (instance) => {
                    const { err } = await toGoLang(() => this.glue.interop.invoke("FSBL.Clients.HotkeyClient.Triggered", { keyArr: params.keyArr }, instance));
                    if (err) {
                        await this.maybeRemove(glueKeyString, instance);
                    }
                });
            });
        }
    }
    async removeAllHotkeysForWindow(params, instance) {
        this.logger.debug("hotkeys - Removing all hotkeys for window", instance.applicationName, instance.instance);
        await asyncForEach(Object.entries(this.hotKeyToWindowMap), async ([glueKeyString, instances]) => {
            if (!instances.map((i) => i.windowId).includes(instance.windowId)) {
                return;
            }
            await this.maybeRemove(glueKeyString, instance);
        });
    }
    async removeGlobalHotkey(params, instance) {
        const glueKeyString = convertFinsembleKeyArrToGlueKeyString(params.keyArr);
        await this.maybeRemove(glueKeyString, instance);
    }
    async maybeAddFinsembleSpecificHotkeys(manifest) {
        const showCentralLogger = manifest.finsemble?.servicesConfig?.logger?.hotkeyShowCentralLogger;
        if (showCentralLogger) {
            const glueKeyString = convertFinsembleKeyArrToGlueKeyString(showCentralLogger);
            this.logger.debug("hotkeys - HotkeyService adding hotkey hotkeyShowCentralLogger", glueKeyString);
            await this.glue.hotkeys.register(glueKeyString, async () => {
                const win = this.glue.windows.find("central-logger");
                if (win) {
                    win.show();
                    win.focus();
                }
            });
        }
    }
    async start(manifest) {
        await this.glue.interop.register("FSBL.Clients.HotkeyClient.addGlobalHotkey", safeInteropRegister(async (params, caller) => this.addGlobalHotkey(params, caller), this.logger));
        await this.glue.interop.register("FSBL.Clients.HotkeyClient.removeAllHotkeysForWindow", safeInteropRegister(async (params, caller) => this.removeAllHotkeysForWindow(params, caller), this.logger));
        await this.glue.interop.register("FSBL.Clients.HotkeyClient.removeGlobalHotkey", safeInteropRegister(async (params, caller) => this.removeGlobalHotkey(params, caller), this.logger));
        await this.maybeAddFinsembleSpecificHotkeys(manifest);
    }
}
